import TypeSelector from './TypeSelector';

export default TypeSelector;